import { carrierAccounts } from '@cimpress-technology/logistics-configuration-client'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import DocumentTypeView from './DocumentTypeView'
import { getUploadLabel } from './uploadEditorFactory'
import styles from './UploadView.module.css'
import { CommonProps } from './uploadViewFactory'

interface Props extends CommonProps {
  upload: carrierAccounts.models.FtpUpload
}
export default function FtpUploadView(props: Props) {
  const name = getUploadLabel(props.upload.uploadType)
  const { t } = useTranslation()

  return (
    <>
      <h6 className={styles.uploadViewHeader}>
        {t('carrierAccounts.uploads.uploadTitle', { name })}
      </h6>
      <DocumentTypeView
        documentTypeList={props.documentTypeList}
        documentTypes={props.upload.documentTypes}
      />
      <div className={styles.uploadView}>
        <div>{t('carrierAccounts.uploads.hostName')}</div>
        <div>{props.upload.host}</div>
      </div>
      <div className={styles.uploadView}>
        <div>{t('carrierAccounts.uploads.hostPort')}</div>
        <div>{props.upload.port}</div>
      </div>
      <div className={styles.uploadView}>
        <div>{t('carrierAccounts.uploads.username')}</div>
        <div>{props.upload.username}</div>
      </div>{' '}
      <div className={styles.uploadView}>
        <div>{t('carrierAccounts.uploads.password')}</div>
        <div>***</div>
      </div>
      <div className={styles.uploadView}>
        <div>{t('carrierAccounts.uploads.directory')}</div>
        <div>{props.upload.directory}</div>
      </div>
      {props.upload.afterUploadMoveToDirectory && (
        <div className={styles.uploadView}>
          <div>{t('carrierAccounts.uploads.afterUploadMoveToDirectory')}</div>
          <div>{props.upload.afterUploadMoveToDirectory}</div>
        </div>
      )}
      {props.upload.uploadType === 'sftp' && (
        <div className={styles.uploadView}>
          <div>{t('carrierAccounts.uploads.authenticationMethod')}</div>
          <div>{props.upload.authenticationMethod}</div>
        </div>
      )}
    </>
  )
}
